import { render, staticRenderFns } from "./WeeklyBudgetChartMemoryAlert.vue?vue&type=template&id=47926c45"
var script = {}
import style0 from "./WeeklyBudgetChartMemoryAlert.vue?vue&type=style&index=0&id=47926c45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports